import { Request } from 'express';

export const getOrigin = (req: Request) => {
  if (req.headers['custom-domain-host']) {
    const host = req.headers['custom-domain-host'];
    const protocol = req.hostname === 'localhost' ? 'http' : 'https';
    return `${protocol}://${host}`;
  }
  if (req.headers['x-forwarded-host']) {
    const protocol = req.headers['x-forwarded-proto'];
    const host = req.headers['x-forwarded-host'];
    return `${protocol}://${host}`;
  }

  const host = req.headers.host;
  const protocol = req.hostname === 'localhost' ? 'http' : 'https';
  return `${protocol}://${host}`;
};
